import { render, staticRenderFns } from "./pirates-band.vue?vue&type=template&id=d5bff4d0&scoped=true&"
import script from "./pirates-band.vue?vue&type=script&lang=js&"
export * from "./pirates-band.vue?vue&type=script&lang=js&"
import style0 from "./pirates-band.vue?vue&type=style&index=0&id=d5bff4d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bff4d0",
  null
  
)

export default component.exports